//
//
//
//
//
//

export default {
    name: 'App',
    created() {},
}



// WEBPACK FOOTER //
// ./src/App.vue